angular.module('cfn').directive('cfnBookingStockyard', [
  '$rootScope',
  '$http',
  '$log',
  'companyFinanceService',
  'userSettingsService',
  function(
    $rootScope,
    $http,
    $log,
    companyFinanceService,
    userSettingsService
  ) {
    return {
      restrict: 'E',
      templateUrl: require('./stockyardTable.html'),
      controller: [
        '$scope',
        function($scope) {
          $scope.isEngland = userSettingsService.getIsoCountryEnum() === 'GBR';
          // All Stockyard-Items saved in this Array
          $scope.items = [];

          $scope.currencySign = companyFinanceService.getCurrencySign();

          // Calculate Sum on Item-Change
          $scope.$watch(
            'items',
            function() {
              var sumPrice = 0;
              $scope.items.forEach(function(value) {
                if (value.costsGrossPrice && value.amount)
                  sumPrice += value.costsGrossPrice * value.amount;
              });
              $scope.sumPrice = sumPrice;
            },
            true
          );

          $scope.goBackToCore = function(content, id) {
            $scope.$emit(
              'goToCore',
              '/core/' + firstLower(content) + '/' + (id || '')
            );
          };

          // Add a new Article (Fertilizer, PlantProtectant, Seed, HarvestType) (from Popup) to items-Array
          $scope.add = function(popupItem) {
            var newItem = {
              amount: 0,
              unit: popupItem.stockyardDisplayUnit || popupItem.unit,
              number: popupItem.number,
              id: popupItem.id,
              costsGrossPrice: popupItem.grossprice || 0,
              currencyUnit: 'CURRENCY_EURO',
              item: popupItem,
              displayName:
                popupItem.displayName ||
                popupItem.sysPlantProtectant_tradeName ||
                popupItem.name
            };

            if (popupItem._objectType == 'fertilizer') {
              newItem.supplyType = 'Fertilizer';
              $scope.items.push(newItem);
            }

            if (popupItem._objectType == 'plantprotectant') {
              newItem.supplyType = 'PlantProtectant'; // UpperCamelCase!
              $scope.items.push(newItem);
            }

            if (popupItem._objectType == 'seed') {
              newItem.supplyType = 'Seed';
              $scope.items.push(newItem);
            }

            if (popupItem._objectType == 'sysharvesttype') {
              newItem.supplyType = 'SysHarvestType'; // ForEnum
              newItem.harvestType = popupItem.dbType;
              $scope.items.push(newItem);
            }
          };

          // Remove the item from the Array
          $scope.remove = function(item) {
            for (var i = $scope.items.length - 1; i >= 0; i--) {
              if ($scope.items[i] == item) {
                $scope.items.splice(i, 1);
              }
            }
          };

          $scope.prepareLoad = function(section, details) {
            if ($scope.ele.name.toLowerCase() == section.toLowerCase()) {
              $scope.items = [];
              details.supplies.forEach(function(value) {
                value.displayName = value.supply.nameString;
                value.number = value.supply.number;
                value.id = value.supply.id;
                value.supplyType = value.supply.objectsType;
                $scope.items.push(value);
              });
              details.products.forEach(function(value, key) {
                value.displayName = value.harvestProduct
                  ? value.harvestProduct.nameString
                  : value.id;
                value.supplyType = 'SysHarvestType'; // ForEnum
                value.costsGrossPrice = value.grossPrice;
                $scope.items.push(value);
              });
            }
          };

          $scope.prepareSave = function(section, details) {
            if ($scope.ele.name == section) {
              $scope.items.forEach(function(value) {
                var detailItem = angular.copy(value);
                // we send detailItem to Server and don't need all the properties
                delete detailItem.item;
                delete detailItem.displayName;
                delete detailItem.number;
                delete detailItem.icon;
                delete detailItem.id;

                if (
                  value.supplyType == 'Fertilizer' ||
                  value.supplyType == 'PlantProtectant' ||
                  value.supplyType == 'Seed'
                ) {
                  detailItem.supply = {
                    id: (value.item || value.supply).id,
                    nameString: value.displayName, // for gotoWithBackButton
                    number: value.number,
                    objectsType: value.supplyType
                  };
                  details.supplies.push(detailItem);
                }

                if (value.harvestType) {
                  delete detailItem.supplyType;
                  detailItem.harvestProduct = {
                    id: (value.item || value.harvestProduct).id,
                    harvestType: (value.item || value.harvestProduct).dbType, // 'CROP','STRAW',###
                    nameString: value.displayName, // for gotoWithBackButton
                    objectsType: 'HarvestType'
                  };
                  // Products needs grossPrice - not costsGrossPrice!!
                  detailItem.grossPrice = detailItem.costsGrossPrice;
                  delete detailItem.costsGrossPrice;
                  details.products.push(detailItem);
                }
              });
            }
          };

          $scope.onClear = function() {
            $scope.items = [];
          };
        }
      ]
    };
  }
]);
